import React, { useEffect, useState }from'react';

import PrivacyPolicyHtml from '../partials/components/PrivacyPolicyHtml.txt' 

          
const PrivacyPolicy = () => {

    let[htmlFileString, setHtmlFileString] = useState();

    const fetchHtml = async () => {
        setHtmlFileString(await (await fetch(PrivacyPolicyHtml)).text());
    }
     
    useEffect(() => {
    fetchHtml();
    }, []);

    return (
        <div dangerouslySetInnerHTML={{ __html: htmlFileString }} />
    );
}

export default PrivacyPolicy;

